<template>
  <v-col>
    <v-container fluid>
      <v-row no-gutters class="row1">
        <v-col>
          <vuetify-google-autocomplete
              solo
              color="main"
              background-color="white"
              append-icon="mdi-map-marker"
              class="location"
              id="location"
              ref="location"
              type="address"
              :enable-geolocation="true"
              placeholder="Your waste address..."
              v-on:placechanged="locationChange"
              v-model="capturedAddress"
              country="usa"
          >

          </vuetify-google-autocomplete>
        </v-col>
        <v-col class="col2">
          <v-btn
            class="col2-btn"
            height="48"
            v-on:click="proceed"
            color="primary"
        >Continue</v-btn>
        </v-col> 
      </v-row>
      <v-row v-if="this.show" no-gutters>
        <v-col xs="16" sm="16" md="3">
          <v-text-field
          solo
          type="number"
          label="Postal Code"
          v-model="postCode"
          @change="checkPostalCode"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <h3 style="font-family: Avenir1;">or call <a href="tel:+27722459777" class="primry--text">072 245 9777</a></h3>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>

export default {
  name: "Address",
  props: {
      locationChangeCallback: Function
  },
  data () {
    return {
      canProceed: false,
      location: {},
      capturedAddress: '',
      postCode: '',
      show: false
    }
  },
  methods: {
    locationChange(to) {
        this.canProceed = true;
        this.location = to;
        if (this.location.postal_code){
          this.show = false;
        }
        else{
          this.show = true;
        }
    },
    checkPostalCode(){
      if(this.postCode == '' || !this.postCode){
        alert('Please enter the post code for your address');
        this.canProceed = false;
      }
      else{
        this.canProceed = true;
      }
    },
    async proceed() {
      if (!this.location.postal_code && this.postCode.length != 4){
        this.canProceed = false;
        alert('Please enter correct post code for your address');
      }
      else{
        this.canProceed = true;
        this.locationChangeCallback(this.location, this.capturedAddress, this.postCode);
      }
    }
  },
  mounted(){
  }
}
</script>

<style scoped>
.location{
  font-size: 23px;
  border-top-right-radius: 0px; 
  border-bottom-right-radius: 0px;
}
.col2-btn{
  border-top-left-radius: 0px; 
  border-bottom-left-radius: 0px;
}

@media screen and (max-width: 480px){
  .row1{
    display: inline-block; 
    margin-bottom: 1.5cm;
  }
  .location{
    border-radius: 5px;
  }
  .col2{
    margin-top: -0.5cm;
  }
  .col2-btn{
    width: 100%;
    border-radius: 30px;
  }

}

</style>